<div class="header">
  <div class="logo">
    <div class="img">
      <img src="../../../../assets/image/new-deals/ARCA_LINK.jpg" alt="" />
    </div>
  </div>
  <div class="lang">
    <div class="img">
      <img
        (click)="toggleLangList()"
        src="../../../../assets/image/new-deals/Globe_Icon1.png"
        alt=""
      />
      <span *ngIf="lang && !currentLang">{{
        lang == "en" ? "ENG" : lang == "ru" ? "РУС" : "ՀԱՅ"
      }}</span>
      <span *ngIf="lang && currentLang">
        {{ currentLang }}
      </span>
    </div>
    <div class="lang-list" *ngIf="isLangListVisible">
      <ul>
        <li class="am" (click)="changeLang('am')">
          <!-- <img
            (click)="changeLang('am')"
            src="../../../../assets/image/user-paid-unpaid/armenia.png"
            alt="Armenia"
          /> -->
          ՀԱՅ
        </li>
        <li class="ru" (click)="changeLang('ru')">
          <!-- <img
            (click)="changeLang('ru')"
            src="../../../../assets/image/user-paid-unpaid/russia.png"
            alt="Russia"
          /> -->
          РУС
        </li>
        <li class="en" (click)="changeLang('en')">
          <!-- <img
            (click)="changeLang('en')"
            src="../../../../assets/image/user-paid-unpaid/Flag_of_the_United_Kingdom.svg.png"
            alt="United States"
          /> -->
          ENG
        </li>
      </ul>
    </div>
  </div>
</div>
